import React from 'react';
import './GuestApplication.css';

const GuestApplication = () => {
  return (
    <section id="guest" className="guest-application">
      <div className="guest-container">
        <div className="guest-header">
          <h2 className="guest-title">Got a Story Worth Telling?</h2>
          <p className="guest-subtitle">
            We're always looking for guests who inspire change, spark laughter, or share lessons from real experience.
          </p>
          <p className="guest-description">
            Whether you're an artist, entrepreneur, or everyday leader — we want to hear from you.
          </p>
        </div>
        
        <div className="guest-email-section">
          <p className="guest-email-text">
            Email us at{' '}
            <a href="mailto:caliraydllc@gmail.com" className="guest-email-link">
              caliraydllc@gmail.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default GuestApplication;